__webpack_require__.p = "/magpie3-mental-rotation/";